// @flow
import React from 'react';

import { colors } from '@peachjar/components';

const { dragon, leaf } = colors;

const messageClasses = {
  success: leaf,
  error: dragon,
};

type Message = 'success' | 'error';

type Props = {
  percentage: number,
  message: Message,
};

const ProgressBar = (props: Props) => (
  <div className="progress" style={{ marginBottom: '0' }}>
    <div
      className="progress-bar"
      role="progressbar"
      style={{
        width: `${props.percentage}%`,
        backgroundColor: messageClasses[props.message],
      }}
      aria-valuenow={props.percentage}
      aria-valuemin="0"
      aria-valuemax="100"
    />
  </div>
);

ProgressBar.defaultProps = {
  message: 'success',
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff/components/ProgressBar.jsx